import PropTypes from 'prop-types'
import React, { Component } from 'react'

import './ToggleVertical.scss'

/**
 * ToggleHorizontal component
 * @param {Boolean} action - for toggle-vertical
 * @return {Component} Component - ToggleHorizontal
 */
class ToggleVertical extends Component {
  static propTypes = {
    /** Function which call after toggle-vertical */
    toggleCb: PropTypes.func.isRequired,

    /** Initial toggle-vertical state */
    initial: PropTypes.bool,

    /** Disable toggle-vertical */
    isDisabled: PropTypes.bool,

    /** Text for false label */
    labelFalse: PropTypes.string,

    /** Text for true label */
    labelTrue: PropTypes.string,

    /** Extra content for true value description */
    trueValueSubContent: PropTypes.node,
  }

  static defaultProps = {
    initial: false,
    labelTrue: '',
    labelFalse: '',
    isDisabled: false,
  }

  state = {
    active: this.props.initial,
  }

  set = action => {
    const { isDisabled, toggleCb } = this.props
    const { active } = this.state
    const biomeType = action ? 'subscription' : 'kits'

    if (isDisabled || active === action) {
      return false
    }
    this.setState({ active: action }, () => toggleCb(biomeType))

    return true
  }

  render() {
    const {
      labelTrue,
      labelFalse,
      isDisabled,
      trueValueSubContent,
    } = this.props
    const { active } = this.state
    const falseClassName = active ? '' : 'active'
    const trueClassName = active ? 'active' : ''
    let classes = active ? 'toggle-vertical--active ' : ''

    classes += isDisabled ? 'toggle-vertical--disabled' : ''

    return (
      <div className={`toggle-vertical ${classes}`}>
        <div className="toggle-vertical__label" onClick={() => this.set(false)}>
          <span
            className={`toggle-vertical__label-text ${falseClassName}`}
            dangerouslySetInnerHTML={{ __html: labelFalse }}
          />
        </div>

        <label className={`toggle-vertical__body ${trueClassName}`}>
          <input
            className="toggle-vertical__checkbox"
            type="checkbox"
            disabled={isDisabled}
            onClick={() => this.set(!active)}
          />
        </label>

        <div className="toggle-vertical__label">
          <span
            className={`toggle-vertical__label-text ${trueClassName}`}
            dangerouslySetInnerHTML={{ __html: labelTrue }}
            onClick={() => this.set(true)}
          />
          {trueValueSubContent}
        </div>
      </div>
    )
  }
}

export default ToggleVertical
